var React = require('react');

function FoodCatchCoupon (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-40.671 -3539.304)"},[React.createElement("text",{"transform":"translate(187.5 3559)","fill":"#0e2a77","fontSize":"21","fontFamily":"AB-kirigirisu","key":0},React.createElement("tspan",{"x":"-109.904","y":"0"},"人気食堂が10%オフ！")),React.createElement("line",{"x2":"11","y2":"21","transform":"translate(42 3540)","fill":"none","stroke":"#f1d901","strokeWidth":"3","key":1}),React.createElement("line",{"x1":"11","y2":"21","transform":"translate(322 3540)","fill":"none","stroke":"#f1d901","strokeWidth":"3","key":2})]));
}

FoodCatchCoupon.defaultProps = {"viewBox":"0 0 293.657 22.696"};

module.exports = FoodCatchCoupon;

FoodCatchCoupon.default = FoodCatchCoupon;
